<template>
  <div>
    VOD-APP
    <v-btn @click="logout">Logout</v-btn>
  </div>
  <!-- <v-container text-xs-center>
    <v-layout row wrap>
      <v-flex
        md6
        sm12
        lg6
        xl4
        v-for="(category, i) in $store.getters.getFilteredCategories"
        :key="category.id + i"
        class="text-xs-center">
        <Category @selectedCategory="selectCategory($event)" :category-prop="category" />
      </v-flex>    
    </v-layout>     
  </v-container> -->
</template>

<script>
// import Category from "./home/HomeCategory";
import { mapActions } from "vuex";

export default {
  name: "Home",
  components: {
    // Category
  },
  data() {
    return {};
  },
  methods: {
    ...mapActions(["logoutUser"]),
    logout() {
      this.logoutUser();
    }
    // selectCategory(cat) {
    //   if (this.$store.getters.getDisplayExists) {
    //     this.$store.dispatch("resetDisplayOffTimer");
    //   }
    //   this.$store.dispatch("changeCategory", cat);
    //   this.$router.push("Category");
    // }
  } 
};
</script>





// WEBPACK FOOTER //
// src/components/Home.vue